const LightTheme = {
  "--b1": "#ffffff",
  "--b2": "#e8e8e8",
  "--b3": "#dedede",
  "--b4": "#d1d1d1",
  "--f1": "#000000",
  "--s1": "#000000",
  "--s2": "#FFFFFF",
  "--s3": "#33C9FF",
  "--s4": "#1DB954",
  "--s5": "#1ED75F",
  "--s6": "#5EAE59",
  "--s7": "#2C2D4D"
};

export default LightTheme;
